import { Box, Typography } from '@mui/material';

export const DefaultPage = () => {
  return (
    <Box
      height="100%"
      display="flex"
      justifyContent="center"
      alignItems="center"
    >
      <Typography variant="h1" color="primary">Please pick an option from the menu on the left or contact support</Typography>
    </Box>
  );
};